export default "__VITE_ASSET__698365bc__"